module.exports = __webpack_public_path__ + "img/icon_order_wait.5731f200.png";